import Vue from 'vue';
import Viewer from 'v-viewer'
import App from './App';
import router from './router';
import mitt from "mitt"

// 引入图片预览插件
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
// Viewer.setDefaults({
//     Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
// })

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import './common/styles/ress.css'
import './common/styles/scss/public.scss'
import './common/styles/scss/table.scss'

import './common/iconfont/iconfont.css';
import './common/font-family/font-family.css';

import './core/install'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import Util from './core/utils'
Vue.prototype.$Util = Util;
Vue.prototype.$auth = Util.auth;
Vue.prototype.$device = Util.device;
Vue.prototype.$flag = Util.flag;

import Const from './core/const'
Vue.prototype.$C = Const;

Vue.prototype.$Bus = new mitt();

// 全局过滤器
import * as Filters from './core/filters.js'
Object.keys(Filters).forEach(filterName => {
    Vue.filter(filterName, Filters[filterName])
})
Vue.prototype.$Filter = Filters;

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app');
